import React, { useState, useEffect } from 'react';
import CustomLink from '@bit/gerenciatd.unifiedcomponents.custom-link';
import Modal, {
  CONTENT_POSITION,
  OPACITY_LAYOUT_COLORS,
  IN_SCENE_EFFECT,
  OUT_SCENE_EFFECT,
} from '@bit/gerenciatd.unifiedcomponents.modal';
import VideoAutoPlay from '../PlayVideo';
import ContainerText from './ContainerText';
import './VideoBanner.scss';

import Video from '../Video';

export const COMPONENT_NAME = 'Video';

/**
 * Asigna las propiedades al modal
 */
const setUpModalProps = () => {
  Modal.setModalProps({
    contentPosition: CONTENT_POSITION.CENTER_CENTER,
    opacityLayoutColor: OPACITY_LAYOUT_COLORS.BLACK05,
    inSceneEffect: IN_SCENE_EFFECT.FADE_IN_RIGHT,
    outSceneEffect: OUT_SCENE_EFFECT.FADE_OUT_RIGHT,
    closeByClickingOutside: true,
    scrollAllowed: true,
  });
};

const VideoBanner = ({
  claim, subClaim, bucleVideo, urlVideo, title, button, imgDesktop
}) => {
  const [windowSize, setWindowSize] = useState({
    width: undefined,
  });
  useEffect(() => {
    // Handler to call on window resize
    function handleResize() {
      // Set window width/height to state
      setWindowSize({
        width: window.innerWidth,
      });
    }
    // Add event listener
    window.addEventListener('resize', handleResize);
    // Call handler right away so state gets updated with initial window size
    handleResize();
    // Remove event listener on cleanup
    return () => window.removeEventListener('resize', handleResize);
  }, []); // Empty array ensures that effect is only run on mount

  const handleModal = () => {
    setUpModalProps();
    Modal.setContent(
      <Video urlVideo={urlVideo} />
    );
    return Modal.show();
  };

  return (
    <div className="VideoBanner">
      <CustomLink
        taggingInfo={{
          componentContent: 'play',
          componentProduct: '',
          componentVariation: 'all',
          componentName: COMPONENT_NAME,
        }}
        onClick={handleModal}
        className="custom-play"
      >
        <span>
          <VideoAutoPlay video height="banner" width="banner" imgDesktop={imgDesktop} bucleVideo={bucleVideo} urlVideo={urlVideo} playIcon={windowSize.width <= 1260}>
            {
          windowSize.width && windowSize.width > 1260
          && <ContainerText claim={claim} subClaim={subClaim} urlVideo={urlVideo} title={title} button={button} />
        }
          </VideoAutoPlay>
        </span>
      </CustomLink>
      {
        windowSize.width && windowSize.width <= 1260
        && <ContainerText claim={claim} subClaim={subClaim} urlVideo={urlVideo} title={title} button={button} />
      }
    </div>
  );
};

export default VideoBanner;
